// Stripe's payout failure codes, as a restaurant reads them (the owner's
// "Payout States" mock, frames 5d and 5f): a short reason in bold, then what
// it means. Stripe's own `failure_message` is written for the account
// holder, so a code this table has no words for falls back to it, and a
// payout with neither gets the one sentence that is always true.
const REASONS = {
  account_closed: ['Account closed.', 'The bank account has been closed.'],
  account_frozen: ['Account frozen.', 'Your bank rejected the deposit.'],
  bank_account_restricted: ['Account restricted.', 'The bank account does not accept this kind of deposit.'],
  bank_ownership_changed: ['Account ownership changed.', 'The bank account no longer belongs to your business.'],
  could_not_process: ['Could not process.', 'The bank could not process this payout.'],
  debit_not_authorized: ['Debit not authorized.', 'The bank account does not allow debits.'],
  declined: ['Declined.', 'The bank declined the deposit.'],
  incorrect_account_holder_address: ['Address does not match.', 'The address on the bank account does not match your business details.'],
  incorrect_account_holder_name: ['Name does not match.', 'The name on the bank account does not match your business details.'],
  incorrect_account_holder_tax_id: ['Tax ID does not match.', 'The tax ID on the bank account does not match your business details.'],
  insufficient_funds: ['Insufficient funds.', 'The bank account could not cover the amount.'],
  invalid_account_number: ['Invalid account number.', 'The account number is not valid.'],
  invalid_currency: ['Currency not supported.', 'The bank account does not accept payouts in this currency.'],
  no_account: ['No account.', 'The bank account could not be found.'],
  unsupported_card: ['Card not supported.', 'This card cannot receive payouts.'],
};

export const describeFailure = (code, message) => {
  const known = code ? REASONS[code] : null;
  if (known) return { title: known[0], detail: known[1] };
  return {
    title: 'Deposit refused.',
    detail: message || 'Your bank did not accept this payout.',
  };
};

// What to do next, by state. A failed payout's money is back in the
// balance and leaves with the next payout once a working account is on
// file — Stripe does not retry the payout itself, and "next payout" is
// also true of a company that pays out by hand; a returned one has Stripe
// pausing payouts until the account is changed; a canceled one was never
// sent at all.
export const NEXT_STEP = {
  failed: 'Update your bank details. The money goes out again with your next payout once a valid account is added.',
  returned: 'Contact your bank or add a different account. Future payouts are paused until this is fixed.',
  canceled: 'Nothing was sent to your bank. The amount stays in your balance and goes out with your next payout.',
};

export default REASONS;
